import axios from "axios";
import EnvConfig from "./EnvConfig";
import { enqueueSnackbar } from "notistack";
import { startFirebaseTrace, stopFirebaseTrace } from "../firebase";
import { captureApiError, captureCustom200Error } from "../sentry";

const locId = localStorage.getItem("locId") || "";
const orgId = localStorage.getItem("orgId") || "";

const instance = axios.create({
  baseURL: EnvConfig().baseConfigUrl,
  timeout: 1000,
  headers: { "X-Custom-Header": "foobar" },
});
const postHeaders = {
  "Content-Type": "application/json",
  USER: "testuser",
  USER_ROLE: "CLIENT",
  at: "",
  org_id: "PALLET",
  platform: "POS",
  rt: "",
  "x-org-id": orgId,
  "x-location-id": locId,

  //'Authorization': 'JWT fefege...'
};

const rtPostHeaders = {
  "Content-Type": "application/json",
  USER: "testuser",
  USER_ROLE: "CLIENT",
  rt: "",
  org_id: "PALLET",

  //'Authorization': 'JWT fefege...'
};

const getHeaders = {
  "Content-Type": "application/json",
  USER: "testuser",
  USER_ROLE: "CLIENT",
  at: "",
};
const deleteHeaders = {
  "Content-Type": "application/json",
  USER: "testuser",
  USER_ROLE: "CLIENT",
  at: "",
};

const patchHeaders = {
  "Content-Type": "application/json",
  USER: "testuser",
  USER_ROLE: "CLIENT",
  at: "",
};

const postMultipartHeaders = {
  "Content-Type": "multipart/form-data",
  USER: "testuser",
  USER_ROLE: "HANDLER",
  at: "",
  //'Authorization': 'JWT fefege...'
};

export const putRequest = (endpoint, data) => {
  const at = localStorage.getItem("access_token");

  //firebase code
  const httpTrace = startFirebaseTrace(`PUT ${endpoint}`); //trace will start
  const startTime = Date.now(); //Record the start time of request

  return new Promise(function (resolve, reject) {
    axios
      .put(endpoint, data, { headers: { ...postHeaders, at: at } })
      .then((res) => {
        if (res?.status === 200 && res?.data && (res?.data?.data?.es || res?.data?.es)) {
          captureCustom200Error(res?.data, endpoint);
        }
        resolve(res);
      })
      .catch((err) => {
        captureApiError(err, endpoint);
        reject(err);
        console.log(`Error in post request to endpoint ${endpoint}`, err);
      })
      .finally(() => {
        // Stop the trace regardless of success or failure
        stopFirebaseTrace(
          httpTrace,
          { status: "no_response" },
          { method: "PUT", url: endpoint },
          startTime
        );
      });
  });
};
export const gettRequest = (endpoint, method, extraHeaders = {}) => {
  const at = localStorage.getItem("access_token");
  return new Promise(function (resolve, reject) {
    const maxRetries = 5;
    let retries = 0;

    //firebase code
    const httpTrace = startFirebaseTrace(`GET ${endpoint}`); //trace will start
    const startTime = Date.now(); //Record the start time of request
    function makeRequest() {
      axios
        .get(endpoint, { headers: { ...getHeaders, at: at, ...extraHeaders } })
        .then((res) => {
          if (res?.status === 200 && res?.data && (res?.data?.data?.es || res?.data?.es)) {
            captureCustom200Error(res?.data, endpoint);
          }
          if (res?.data?.code === "ECONNRESET" && retries < maxRetries) {
            retries++;
            makeRequest();
          } else {
            resolve(res);
          }
        })
        .catch((err) => {
          captureApiError(err, endpoint);
          if (err?.response?.status === 401) {
            Object.keys(localStorage).forEach((key) => {
              if (key !== "printerConfig") {
                localStorage.removeItem(key);
              }
            });
            if (window.location.pathname !== "/") {
              window.location.href = "/";
            }
          }
          if (err?.response?.status === 429 && retries < maxRetries) {
            retries++;
            setTimeout(makeRequest, 1000 * retries);
          } else {
            reject(err);
            console.log(`Error in get request to endpoint ${endpoint}`, err);
          }
        })
        .finally(() => {
          // Stop the trace regardless of success or failure
          stopFirebaseTrace(
            httpTrace,
            { status: "no_response" },
            { method: "GET", url: endpoint },
            startTime
          );
        });
    }
    makeRequest();
  });
};

export const pdfgetRequest = (endpoint) => {
  const at = localStorage.getItem("access_token");
  const httpTrace = startFirebaseTrace(`GET ${endpoint}`);
  const startTime = Date.now();

  return new Promise(function (resolve, reject) {
    fetch(endpoint, {
      headers: { ...getHeaders, at: at },
    })
      .then(async (res) => {
        if (!res.ok) throw new Error("Network response was not ok");

        const blob = await res.blob(); // ✅ IMPORTANT

        resolve(blob); // ✅ return blob directly
      })
      .catch((err) => {
        captureApiError(err, endpoint);
        reject(err);
      })
      .finally(() => {
        stopFirebaseTrace(
          httpTrace,
          { status: "no_response" },
          { method: "GET", url: endpoint },
          startTime
        );
      });
  });
};

export const postFileRequest = (endpoint, data) => {
  const at = localStorage.getItem("access_token");
  const httpTrace = startFirebaseTrace(`POST ${endpoint}`); //trace will start
  const startTime = Date.now(); //Record the start time of request
  return new Promise(function (resolve, reject) {
    axios
      .post(endpoint, data, { headers: { ...postMultipartHeaders, at: at } })
      .then((res) => {
        if (res?.status === 200 && res?.data && (res?.data?.data?.es || res?.data?.es)) {
          captureCustom200Error(res?.data, endpoint);
        }
        resolve(res);
      })
      .catch((err) => {
        captureApiError(err, endpoint);
        reject(err);
        console.log(`Error in post request to endpoint ${endpoint}`, err);
      })
      .finally(() => {
        // Stop the trace regardless of success or failure
        stopFirebaseTrace(
          httpTrace,
          { status: "no_response" },
          { method: "POST", url: endpoint },
          startTime
        );
      });
  });
};
export const patchRequest = (endpoint, data) => {
  const at = localStorage.getItem("access_token");
  const httpTrace = startFirebaseTrace(`PATCH ${endpoint}`); //trace will start
  const startTime = Date.now(); //Record the start time of request
  return new Promise(function (resolve, reject) {
    axios
      .patch(endpoint, data, { headers: { ...patchHeaders, at: at } })
      .then((res) => {
        if (res?.status === 200 && res?.data && (res?.data?.data?.es || res?.data?.es)) {
          captureCustom200Error(res?.data, endpoint);
        }
        resolve(res);
      })
      .catch((err) => {
        captureApiError(err, endpoint);
        reject(err);
        console.log(`Error in patch request to endpoint ${endpoint}`, err);
      })
      .finally(() => {
        // Stop the trace regardless of success or failure
        stopFirebaseTrace(
          httpTrace,
          { status: "no_response" },
          { method: "PATCH", url: endpoint },
          startTime
        );
      });
  });
};
export const deleteRequest = (endpoint, data) => {
  const at = localStorage.getItem("access_token");
  const httpTrace = startFirebaseTrace(`DELETE ${endpoint}`); //trace will start
  const startTime = Date.now(); //Record the start time of request
  return new Promise(function (resolve, reject) {
    axios
      .delete(endpoint, { headers: { ...deleteHeaders, at: at }, data: data })
      .then((res) => {
        if (res?.status === 200 && res?.data && (res?.data?.data?.es || res?.data?.es)) {
          captureCustom200Error(res?.data, endpoint);
        }
        resolve(res);
      })
      .catch((err) => {
        captureApiError(err, endpoint);
        reject(err);
        console.log(`Error in post request to endpoint ${endpoint}`, err);
      })
      .finally(() => {
        // Stop the trace regardless of success or failure
        stopFirebaseTrace(
          httpTrace,
          { status: "no_response" },
          { method: "DELETE", url: endpoint },
          startTime
        );
      });
  });
};

export const postRequest = (endpoint, data, config = {}) => {
  const at = localStorage.getItem("access_token");
  const rt = localStorage.getItem("refresh_token");

  const httpTrace = startFirebaseTrace(`POST ${endpoint}`); //trace will start
  const startTime = Date.now(); //Record the start time of request

  return new Promise(function (resolve, reject) {
    axios
      .post(endpoint, data, {
        ...config,
        headers: { ...postHeaders, at: at, rt: rt, ...(config.headers || {}) },
      })
      .then((res) => {
        if (res?.status === 200 && res?.data && (res?.data?.data?.es || res?.data?.es)) {
          captureCustom200Error(res?.data, endpoint);
        }
        if (res?.data?.code === "ECONNRESET") {
          // enqueueSnackbar("Unable to connect to the server. Please try again.", {
          //   variant: "error",
          // });
          reject(res);
        }
        resolve(res);
      })
      .catch((err) => {
        captureApiError(err, endpoint);
        if (
          err?.response?.status === 401 &&
          (err.response?.message === "Token verification failed" ||
            err.response?.message === "UnAuthorized Token")
        ) {
          Object.keys(localStorage).forEach((key) => {
            if (key !== "printerConfig") {
              localStorage.removeItem(key);
            }
          });
          if (window.location.pathname !== "/") {
            window.location.href = "/";
          }
        }
        reject(err);
        console.log(`Error in post request to endpoint ${endpoint}`, err);
      })
      .finally(() => {
        // Stop the trace regardless of success or failure
        stopFirebaseTrace(
          httpTrace,
          { status: "no_response" },
          { method: "POST", url: endpoint },
          startTime
        );
      });
  });
};

// rtPostRequest

export const rtPostRequest = (endpoint, data) => {
  const rt = localStorage.getItem("refresh_token");
  const httpTrace = startFirebaseTrace(`POST ${endpoint}`); //trace will start
  const startTime = Date.now(); //Record the start time of request
  return new Promise(function (resolve, reject) {
    const apiCall = () => {
      axios
        .post(endpoint, data, { headers: { ...rtPostHeaders, rt: rt } })
        .then((res) => {
          if (res?.status === 200 && res?.data && (res?.data?.data?.es || res?.data?.es)) {
            captureCustom200Error(res?.data, endpoint);
          }
          if (res?.data?.code === "ECONNRESET") {
            apiCall();
            return;
          }
          resolve(res);
        })
        .catch((err) => {
          captureApiError(err, endpoint);
          reject(err);
          console.log(`Error in post request to endpoint ${endpoint}`, err);
        })
        .finally(() => {
          // Stop the trace regardless of success or failure
          stopFirebaseTrace(
            httpTrace,
            { status: "no_response" },
            { method: "POST", url: endpoint },
            startTime
          );
        });
    };
    apiCall();
  });
};
